module.exports = __webpack_public_path__ + "img/18.7a27304e.png";